<template>
  <div>
    随访介绍页
  </div>
</template>

<script>
export default {
  name: "FollowIntroduction",
  data() {
    return {

    }
  },
  created() {

  },
  methods: {

  }
}
</script>

<style lang="less" scoped>

</style>
